import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class GetAiInsightsSelectedReportDataRequest extends BaseServiceRequest {
  constructor(symbol, companyName, stockId, insightCategory) {
    super();
    super.addRequestUri("aiInsights/report");
    super.addRequestParameter("req_symbol", symbol);
    super.addRequestParameter("stock_id", stockId);
    super.addRequestParameter("insight_category", insightCategory);
    super.addRequestParameter("company_name", companyName);
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }

  // getMessageName() {
  //   return "AiInsightsCategoriesResponseData";
  // }
}

export default GetAiInsightsSelectedReportDataRequest;
